import React from 'react';
import styled from 'styled-components';
// import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';
import moment from 'moment';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import {
  // Icon,
  // DatePicker,
  LabeledInput,
  Textarea,
  Label,
  Button,
  // FileInput,
  Loader,
} from 'oxyrion-ui/lib';
import FIleInput from '../../Components/FileInput';
import { handleServiceStataus, FORMAT_HUMANE_DATETIME, __ } from '../../Utils';
import { connect } from '../../Store';
import { Title, LoaderWrapper } from '../../Components/ReusableComponents';
import SelectForm from '../../Components/SelectForm';
import API2 from '../../API2';

const basePath = `${process.env.REACT_APP_IMAGES_PREFIX}/helpdesk`;

const Wrapper = styled.div``;

const ContentWrapper = styled.div`
  width: 90%;
  flex-direction: column;
  max-width: ${rem(690)};
  display: flex;
  justify-content: start;
  padding-top: ${rem(20)};
  ${({ theme }) => theme.media.m`
  width: 100%;
  min-width: ${rem(600)};
`};
`;

const InputWrapper = styled.div`
  padding: ${rem(10)};
`;

const InputWrapperInline = styled.div`
  display: inline-block;
  padding: ${rem(10)};
  vertical-align: bottom;
`;

const ButtonWrapper = styled.div`
  padding: ${rem(10)};
  display: flex;
  justify-content: left;
  align-items: center;
`;

const ButtonSubmit = styled(Button)`
  margin-right: 15px;
`;

// const DatePickerWrapper = styled.div`
//   max-width: ${rem(200)};
//   display: flex;
//   margin-bottom: ${rem(0)};
// `;

const Text = styled.p`
  display: block;
  margin: 0 ${rem(10)};
  padding: 0;
  color: ${({ theme }) => theme.color.base};
`;

const Date = styled(Text)`
  white-space: nowrap;
`;

const Status = styled.span`
  font-weight: bold;
`;

// const StyledDatePicker = styled(DatePicker)`
//   width: 90% !important;
//   z-index: 9000;
// `;

// const CustomIconWrapper = styled.div`
//   width: ${rem(80)};
//   height: ${rem(40)};
//   margin-left: ${rem(50)};
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: #f0f0f0;
// `;

class ModifyService extends React.Component {
  constructor(props) {
    super(props);
    this.editMode = false;
    this.state = {
      name: '',
      description: '',
      poznamka: '',
      descToHistory: '',
      serviceStatus: '',
      history: [],
      date: moment(),
      loading: false,
      fileNames: [],
      files: [],
      filesToDropzone: [],
      imgSrc: [],
      acceptedFiles: [],
      filesToAdd: [
        {
          fileValue: '',
          file: null,
          fileError: false,
          errors: [],
        },
      ],
      selected: [{ value: 'Vyberte' }],
      selected1: [{ value: 'Vyberte' }],
      selected2: [{ value: 'Vyberte' }],
      machines: [],
      formMode: 'add',
      service: {},
      documentsError: '',
    };
  }

  componentDidMount() {
    const { editMode, serviceID } = this.props;
    if (editMode) {
      this.setState({
        formMode: editMode,
      });
    }
    this.fetchMachines();
    if (serviceID !== '') {
      this.fetchService(serviceID);
    }
  }

  componentDidUpdate(prevProps) {
    const { editMode, serviceID } = this.props;
    if (editMode !== prevProps.editMode) {
      this.setState({
        formMode: editMode,
      });
    }
    if (serviceID !== prevProps.serviceID) {
      this.fetchService(serviceID);
    }
  }

  async onDelete() {
    try {
      const { service } = this.state;
      const { history } = this.props;

      await API2.deleteB2BHelpdeskServiceAction(service._id);
      this.props.closePopup();
      history.push(`/helpdesk`);
      return true;
    } catch (e) {
      return false;
    }
  }

  async onSubmit() {
    try {
      const {
        date,
        selected,
        selected1,
        selected2,
        description,
        poznamka,
        filesToDropzone,
        formMode,
        service,
        serviceStatus,
        acceptedFiles,
        machines,
      } = this.state;
      const { history } = this.props;

      if (this.checkData()) {
        this.setState({
          saveLoading: true,
          // success: undefined,
          // saveError: undefined,
        });

        if (formMode === 'add') {
          const selMachineID = [];
          const selMachineType = [];
          const selMachineToning = [];
          if (selected1 && selected1[1] && selected1[1].value) {
            machines.map((machine, index) => {
              if (selected1[1].value[index] === machine.label) {
                selMachineID.push(machine.value);
                selMachineType.push(machine.additionalData.machine_type);
                selMachineToning.push(machine.additionalData.toning_system);
              }
              return true;
            });
          }

          const dataPost = {
            name: selected[0].value,
            case: selected1[0].value,
            machine_id: selMachineID,
            machine_type:
              selected[0].value !== 'Servis stroja' ? selected2[0].value : '',
            toning_system: null,
            description,
            user_id: service.user_id,
            customer_id: service.customer_id,
            solver_id: service.solver_id,
            due_date: date,
          };

          const result = await API2.postB2BHelpdeskServiceAction({
            body: dataPost,
          });

          const historyResult = await this.saveToHistory(poznamka, result);

          if (filesToDropzone && filesToDropzone.length > 0) {
            await Promise.all(
              acceptedFiles.map(item => {
                API2.postB2BHelpdeskServiceAttachmentAction(result._id, {
                  body: { attachment: item },
                });
                return true;
              }),
            );
            this.setState({});
          }
          this.setState({
            service: result,
            history: historyResult.history,
            // success: __('Požiadavka úspešne aktualizovaná'),
            saveLoading: false,
          });
        } else if (formMode === 'edit') {
          const dataPut = {
            name: selected[0].value,
            case: selected1[0].value,
            machine_id: [],
            machine_type: selected2[0].value,
            toning_system: null,
            description,
            status: serviceStatus,
          };

          await API2.putB2BHelpdeskServiceAction(service._id, {
            body: dataPut,
          });

          const historyResult = await this.saveToHistory(poznamka, service);

          this.setState({
            history: historyResult.history,
            // success: __('Požiadavka úspešne aktualizovaná'),
            saveLoading: false,
          });
        }

        this.props.closePopup();
        history.push(`/helpdesk`);
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  async onDrop(accepted) {
    try {
      const {
        filesToDropzone,
        service,
        formMode,
        imgSrc,
        acceptedFiles,
        fileNames,
      } = this.state;
      const normalizedFiles = accepted.map(item => ({
        name: item.name,
        fullPath: item.preview,
        mimeType: item.type,
        loading: true,
        buffer: item.buffer,
      }));
      const newFiles = [...filesToDropzone, ...normalizedFiles];

      this.setState({ filesToDropzone: newFiles });

      const af = acceptedFiles;
      if (accepted.length === 1) {
        af.push(accepted[0]);
      } else {
        accepted.map(item => af.push(item));
      }

      const mt = imgSrc;
      const fn = fileNames;
      accepted.map(item => {
        const fileItemReader = new FileReader();
        fileItemReader.addEventListener(
          'load',
          () => {
            mt.push(fileItemReader.result);
            fn.push(item.name);
          },
          false,
        );
        fileItemReader.readAsDataURL(item);
        return true;
      });

      if (formMode !== 'add') {
        const postedFiles = await Promise.all(
          accepted.map(item =>
            API2.postB2BHelpdeskServiceAttachmentAction(service._id, {
              body: { attachment: item },
            }),
          ),
        );

        this.setState({
          imgSrc: mt,
          acceptedFiles: af,
          fileNames: fn,
          filesToDropzone: [
            ...filesToDropzone,
            ...postedFiles.map(i => ({
              ...i,
              loading: false,
              downloadPath: `${basePath}/${encodeURIComponent(i.fullPath)}`,
            })),
          ],
        });
      } else {
        this.setState({
          imgSrc: mt,
          acceptedFiles: af,
          fileNames: fn,
          filesToDropzone: [
            ...newFiles.map(i => ({
              ...i,
              loading: false,
              downloadPath: `${basePath}/${encodeURIComponent(i.fullPath)}`,
            })),
          ],
        });
      }
      return true;
    } catch (e) {
      return [];
    }
  }

  getServiceTypes() {
    return this.serviceTypes.map(t => {
      return {
        label: t,
        value: t,
      };
    });
  }

  async saveToHistory(descToHistory, service) {
    const result = await API2.putB2bHelpdeskHistoryAction(service._id, {
      body: {
        user_id: service.user_id,
        description: descToHistory,
      },
    });

    return result;
  }

  downloadFile(file) {
    window.open(file.downloadPath);
  }

  handleChange(type, value) {
    let { name, description, poznamka, descToHistory, date } = this.state;
    const { error } = this.state;

    if (error) {
      this.setState({
        // nameError: false,
        error: false,
      });
    }

    if (type === 'name') {
      name = value;
    } else if (type === 'descToHistory') {
      descToHistory = value;
    } else if (type === 'description') {
      description = value;
    } else if (type === 'poznamka') {
      poznamka = value;
    } else if (type === 'date') {
      date = value;
    }

    this.setState({
      name,
      description,
      descToHistory,
      poznamka,
      date,
    });
  }

  changeHandler(value, index) {
    const { selected } = this.state;
    selected[index].value = value;
    this.setState({
      selected,
      serviceError: false,
    });
  }

  changeHandler1(value, index) {
    const { selected1 } = this.state;
    selected1[index] = { value };
    this.setState({
      selected1,
      service1Error: false,
    });
  }

  changeHandler2(value, index) {
    const { selected2 } = this.state;
    selected2[index].value = value;
    this.setState({
      selected2,
      service2Error: false,
    });
  }

  checkData() {
    const { date, selected, selected1 } = this.state;
    let { serviceError, service1Error } = this.state;
    let isValid = true;

    /* if (name.length < 1) {
      nameError = true;
      isValid = false;
    } */
    if (date.length === 10) {
      isValid = false;
    }

    if (selected[0].value === 'Vyberte') {
      isValid = false;
      serviceError = true;
    }
    if (selected1[0].value === 'Vyberte') {
      isValid = false;
      service1Error = true;
    }
    /* if (selected2[0].value === 'Vyberte') {
      isValid = false;
      service2Error = true;
    } */

    this.setState({
      // nameError,
      serviceError,
      service1Error,
      // service2Error,
      error: !isValid && __('Nevyplenené povinné hodnoty'),
    });

    return isValid;
  }

  itemOnChange(filesInput, index) {
    if (filesInput.length) {
      const f = filesInput[0];

      const { files } = this.state;

      files[index] = {
        fileValue: f.name,
        file: f,
        fileError: false,
        errors: [],
      };

      files.push({
        fileValue: '',
        file: null,
        fileError: false,
        errors: [],
      });

      this.setState({
        files,
      });
    }
  }

  removeItem(index) {
    let { files } = this.state;

    files = files.splice(index, 1);

    this.setState(files);
  }

  async removeItemDropzone(file) {
    try {
      const {
        filesToDropzone,
        service,
        formMode,
        imgSrc,
        acceptedFiles,
      } = this.state;

      const f = filesToDropzone.find(i => i === file);
      f.loading = true;
      this.setState({ filesToDropzone });

      if (formMode !== 'add') {
        await API2.deleteB2BHelpdeskServiceAttachmentAction(
          encodeURIComponent(file.fullPath),
          service._id,
        );
      }

      filesToDropzone.map((d, i) => {
        if (d === file) {
          this.setState({
            imgSrc: imgSrc.filter((b, index) => index !== i),
            acceptedFiles: acceptedFiles.filter((b, index) => index !== i),
          });
          return true;
        }
        return false;
      });

      this.setState({
        filesToDropzone: filesToDropzone.filter(i => i !== file),
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  fileOnChange(filesInput, index) {
    if (filesInput.length) {
      const f = filesInput[0];

      const { filesToAdd } = this.state;

      filesToAdd[index] = {
        fileValue: f.name,
        file: f,
        fileError: false,
        errors: [],
      };

      filesToAdd.push({
        fileValue: '',
        file: null,
        fileError: false,
        errors: [],
      });

      this.setState({
        filesToAdd,
      });
    }
  }

  removeFile(index) {
    let { filesToAdd } = this.state;

    filesToAdd = filesToAdd.splice(index, 1);

    this.setState(filesToAdd);
  }

  async fetchService(serviceID) {
    try {
      this.setState({ loading: true });
      const service = await API2.getB2BHelpdeskServiceAction(serviceID);
      const files = await API2.getB2BHelpdeskServiceAttachmentsAction(
        serviceID,
      );

      const history = await API2.getB2bHelpdeskServiceHistoryAction(serviceID);
      const { machines, selected1 } = this.state;
      const selMachineID = [];
      const selMachineType = [];
      const selMachineToning = [];
      if (service.machine_id && service.machine_id.length > 0) {
        machines.map(machine => {
          if (service.machine_id.indexOf(machine.value) !== -1) {
            selMachineID.push(machine.value);
            selMachineType.push(machine.additionalData.machine_type);
            selMachineToning.push(machine.additionalData.toning_system);
          }
          return true;
        });
      }
      const normalizedFiles = files.map(i => ({
        ...i,
        downloadPath: `${basePath}/${encodeURIComponent(i.fullPath)}`,
      }));

      if (service.name === 'Servis stroja') {
        selected1[1] = { value: selMachineType };
      }

      this.setState({
        service,
        name: service.name,
        description: service.description,
        selected: [{ value: service.name }],
        selected1: [{ value: service.case }, { value: selMachineType }],
        selected2: [{ value: service.machine_type }],
        serviceStatus: service.status,
        loading: false,
        filesToDropzone: normalizedFiles,
        history: history.history,
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  async fetchMachines() {
    try {
      return await API2.getB2BCustomerMachinesAction().then(res => {
        const machines = res.machines.map(item => ({
          value: item._id,
          label: item.name,
          additionalData: {
            machine_type: item.type,
            toning_system: item.toning_system,
          },
        }));
        this.setState({
          machines,
        });
      });
      // return true;
    } catch (e) {
      return [];
    }
  }

  render() {
    const {
      machines,
      loading,
      // name,
      // date,
      description,
      // nameError,
      serviceError,
      service1Error,
      service2Error,
      selected,
      selected1,
      selected2,
      formMode,
      serviceStatus,
      history,
      documentsError,
      filesToDropzone,
      saveLoading,
      poznamka,
      imgSrc,
      riesenie,
    } = this.state;

    if (loading) {
      return (
        <React.Fragment>
          <Wrapper style={{ top: '10%' }}>
            <Title
              style={{
                paddingLeft: '10px',
                textAlign: 'left',
                justifyContent: 'left',
              }}
            >
              {formMode === 'edit' || formMode === 'preview' ? (
                <React.Fragment>
                  {formMode === 'preview'
                    ? __('Požiadavka - Náhľad')
                    : __('Požiadavka - Upraviť')}
                </React.Fragment>
              ) : (
                __('Nová požiadavka')
              )}
            </Title>
            <ContentWrapper>
              <LoaderWrapper>
                <Loader size="xl" />
              </LoaderWrapper>
            </ContentWrapper>
          </Wrapper>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <Wrapper style={{ top: '10%' }}>
          <Title
            style={{
              paddingLeft: '10px',
              textAlign: 'left',
              justifyContent: 'left',
            }}
          >
            {formMode === 'edit' || formMode === 'preview' ? (
              <React.Fragment>
                {formMode === 'preview'
                  ? __('Požiadavka - Náhľad')
                  : __('Požiadavka - Upraviť')}
              </React.Fragment>
            ) : (
              __('Nová požiadavka')
            )}
          </Title>
          <ContentWrapper>
            {/* <ErrorMessage display={error} text={error} /> */}
            <InputWrapper style={{ padding: '0' }}>
              <InputWrapperInline style={{ width: '100%' }}>
                <LabeledInput
                  onChange={e => this.handleChange('name', e.target.value)}
                  style={{ width: '90%' }}
                  labelText={__('Názov')}
                  placeholder={__('Názov')}
                  value={selected[0].value}
                  // error={nameError}
                  disabled
                />
              </InputWrapperInline>
              {/* <InputWrapperInline style={{ width: '29%' }}>
                <Label>{__('Dátum')}</Label>
                <DatePickerWrapper>
                  <StyledDatePicker
                    value={date}
                    labelText={__('Dátum')}
                    // minDate={minDate}
                    isClearable={false}
                    onChange={e => this.handleChange('date', e)}
                    disabled={formMode !== 'add'}
                  />
                  <CustomIconWrapper>
                    <Icon
                      name="clock"
                      size="l"
                      color={baseTheme.color.primary}
                    />
                  </CustomIconWrapper>
                </DatePickerWrapper>
              </InputWrapperInline> */}
            </InputWrapper>
            <InputWrapper>
              <SelectForm
                editMode={formMode}
                name="services"
                machines={machines}
                mainSelect="Služba"
                selectedVal={selected}
                selectedVal1={selected1}
                selectedVal2={selected2}
                // services={this.getServiceTypes()}
                // size="s"
                handleOnChange={(value, index) =>
                  this.changeHandler(value, index)
                }
                handleOnChange1={(value, index) =>
                  this.changeHandler1(value, index)
                }
                handleOnChange2={(value, index) =>
                  this.changeHandler2(value, index)
                }
                error={serviceError}
                error1={service1Error}
                error2={service2Error}
              />
            </InputWrapper>
            {selected[0].value !== 'Vyberte' ? (
              <InputWrapper>
                <Label>{__('Popis')}</Label>
                <Textarea
                  onChange={e =>
                    this.handleChange('description', e.target.value)
                  }
                  style={{ width: '93%', height: rem(50) }}
                  labelText={__('Pridať popis')}
                  placeholder={__('Pridať popis')}
                  value={description}
                  // error={textnoteError}
                  disabled={formMode !== 'add'}
                />
              </InputWrapper>
            ) : null}
            {selected[0].value !== 'Vyberte' &&
            selected[0].value === 'Reklamácia' &&
            formMode === 'add' ? (
              <InputWrapper>
                <Label>{__('Požadované riešenie')}</Label>
                <Textarea
                  onChange={e => this.handleChange('riesenie', e.target.value)}
                  style={{ width: '93%', height: rem(50) }}
                  labelText={__('Pridať Požadované riešenie')}
                  placeholder={__('Pridať Požadované riešenie')}
                  value={riesenie}
                  // error={textnoteError}
                  disabled={formMode === 'preview'}
                />
              </InputWrapper>
            ) : null}
            {selected[0].value !== 'Vyberte' ? (
              <InputWrapper>
                <Label>
                  {__('Pridať poznámku - ak potrebujete doplniť údaje')}
                </Label>
                <div style={{ fontSize: rem(10) }}>
                  Pre pridanie obrázkov k poznámke, použite funkciu “Nahrať”
                  umiestnenú nižšie na tejto stránke.
                </div>
                <Textarea
                  onChange={e => this.handleChange('poznamka', e.target.value)}
                  style={{ width: '93%', height: rem(70) }}
                  labelText={__('Pridať poznámku')}
                  placeholder={__('Pridať poznámku')}
                  value={poznamka}
                  // error={textnoteError}
                  disabled={formMode === 'preview'}
                />
              </InputWrapper>
            ) : null}
            {selected[0].value !== 'Vyberte' && formMode !== 'adds' ? (
              <InputWrapper>
                <Label>{__('Nahrať (napr. obrázok, dokument')}</Label>
                {formMode === 'add' ? (
                  <FIleInput
                    hideMessage
                    onDrop={(a, r) => this.onDrop(a, r)}
                    files={filesToDropzone}
                    removeItem={file => this.removeItemDropzone(file)}
                    onClick={file => this.downloadFile(file)}
                    error={documentsError}
                    // defaultPath={basePath}
                    imgSrc={imgSrc}
                    disabled={formMode === 'preview'}
                  />
                ) : null}
                {formMode !== 'add' ? (
                  <FIleInput
                    hideMessage
                    onDrop={(a, r) => this.onDrop(a, r)}
                    files={filesToDropzone}
                    removeItem={file => this.removeItemDropzone(file)}
                    onClick={file => this.downloadFile(file)}
                    error={documentsError}
                    defaultPath={basePath}
                    // imgSrc={imgSrc}
                    disabled={formMode === 'preview'}
                  />
                ) : null}
              </InputWrapper>
            ) : null}
            {selected[0].value !== 'Vyberte' ? (
              <InputWrapper>
                <Label style={{ fontSize: rem(25) }}>{__('Stav')}</Label>
                {history && history.length > 0 ? (
                  history.map((item, index) => (
                    <ContentWrapper
                      key={index.toString()}
                      style={{
                        paddingBottom: '10px',
                        fontSize: rem(13),
                        borderBottom: '1px solid #ccc',
                      }}
                    >
                      <Date>
                        {moment(item.created_date).format(
                          FORMAT_HUMANE_DATETIME,
                        )}
                      </Date>
                      <Text>
                        <Status>{handleServiceStataus(serviceStatus)}</Status>
                        {item.description ? ` - ${item.description}` : ''}
                      </Text>
                    </ContentWrapper>
                  ))
                ) : (
                  <Textarea disabled style={{ width: '93%' }} />
                )}
              </InputWrapper>
            ) : null}
            <ButtonWrapper>
              {formMode !== 'preview' ? (
                <ButtonSubmit
                  onClick={() => this.onSubmit()}
                  primary
                  loading={saveLoading}
                >
                  {__('Uložiť')}
                </ButtonSubmit>
              ) : null}
              {formMode === 'edit' ? (
                <Button onClick={() => this.onDelete()} danger>
                  {__('Zmazať')}
                </Button>
              ) : null}
            </ButtonWrapper>
          </ContentWrapper>
        </Wrapper>
      </React.Fragment>
    );
  }
}

ModifyService.propTypes = {
  data: PropTypes.shape({}),
  serviceID: PropTypes.string,
  editMode: PropTypes.string.isRequired,
  closePopup: PropTypes.bool.isRequired,
  history: PropTypes.shape({}).isRequired,
};

ModifyService.defaultProps = {
  data: {},
  serviceID: '',
};

const mapStateToProps = state => {
  return { userData: state };
};

export default connect(state => mapStateToProps(state))(ModifyService);



// WEBPACK FOOTER //
// ./src/Containers/ModifyService/index.jsx